var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.c638af62e9990ec5692bb0820cd4d1ca.svg#v';
                    var viewUrl = 'sprites.c638af62e9990ec5692bb0820cd4d1ca.svg#view-v';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };